export const LIFE_EXPECTANCIES_WHAT_IF_KEY = 2;
export const LIFE_EXPECTANCIES_WHAT_IF_PATH = 'WhatIfLifeExpectancies';
